var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.75C10.8624 15.75 11.1562 15.4562 11.1562 15.0938C11.1562 14.7313 10.8624 14.4375 10.5 14.4375C10.1376 14.4375 9.84375 14.7313 9.84375 15.0938C9.84375 15.4562 10.1376 15.75 10.5 15.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 5.90625C9.84375 5.54381 10.1376 5.25 10.5 5.25C10.8624 5.25 11.1562 5.54381 11.1562 5.90625V11.8125C11.1562 12.1749 10.8624 12.4688 10.5 12.4688C10.1376 12.4688 9.84375 12.1749 9.84375 11.8125V5.90625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97656 1.8125H14.0234C14.156 1.81254 14.2832 1.86525 14.377 1.95898L19.041 6.62305C19.1347 6.71678 19.1875 6.84401 19.1875 6.97656V14.0234C19.1875 14.156 19.1347 14.2832 19.041 14.377L14.377 19.041C14.2832 19.1347 14.156 19.1875 14.0234 19.1875H6.97656C6.84401 19.1875 6.71678 19.1347 6.62305 19.041L1.95898 14.377C1.86525 14.2832 1.81254 14.156 1.8125 14.0234V6.97656C1.81254 6.84401 1.86525 6.71678 1.95898 6.62305L6.62305 1.95898C6.71678 1.86525 6.84401 1.81254 6.97656 1.8125Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.b3b47fdde4ffc3514e8f4e1e23884803.svg";
export { ForwardRef as ReactComponent };